var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-card",
        { staticClass: "search-card", attrs: { shadow: "never" } },
        [
          _c(
            "el-form",
            {
              staticClass: "demo-form-inline",
              attrs: { inline: true, model: _vm.queryParams },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "状态" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择状态", clearable: "" },
                      model: {
                        value: _vm.queryParams.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.queryParams, "status", $$v)
                        },
                        expression: "queryParams.status",
                      },
                    },
                    [
                      _c("el-option", { attrs: { label: "成功", value: "1" } }),
                      _vm._v(" "),
                      _c("el-option", { attrs: { label: "失败", value: "0" } }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "类型" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择类型", clearable: "" },
                      model: {
                        value: _vm.queryParams.type,
                        callback: function ($$v) {
                          _vm.$set(_vm.queryParams, "type", $$v)
                        },
                        expression: "queryParams.type",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "商品全量同步", value: "1" },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "单品同步", value: "2" },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "刷新缓存", value: "3" },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "门店菜单商品上下架", value: "4" },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "商品上下架", value: "5" },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "后台操作解估/估清", value: "6" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "时间范围" } },
                [
                  _c("el-date-picker", {
                    attrs: {
                      type: "daterange",
                      "range-separator": "至",
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期",
                      format: "yyyy-MM-dd HH:mm:ss",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                    },
                    model: {
                      value: _vm.dateRange,
                      callback: function ($$v) {
                        _vm.dateRange = $$v
                      },
                      expression: "dateRange",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", icon: "el-icon-search" },
                      on: { click: _vm.handleQuery },
                    },
                    [_vm._v("搜索")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-card",
        { staticClass: "table-card", attrs: { shadow: "never" } },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: { data: _vm.logList, border: "" },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "id", label: "ID", width: "100" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "status", label: "状态", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type:
                                scope.row.status === 1 ? "success" : "danger",
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  scope.row.status === 1 ? "成功" : "失败"
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "type", label: "类型", width: "200" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(_vm.getTypeText(scope.row.type))),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "startTime", label: "开始时间", width: "180" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "endTime", label: "结束时间", width: "180" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "createBy", label: "操作人", width: "150" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "errMsg",
                  label: "错误信息",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作", width: "150", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.handleDetail(scope.row.id)
                              },
                            },
                          },
                          [_vm._v("\n            详情\n          ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.total > 0
            ? _c("el-pagination", {
                staticStyle: { "margin-top": "20px" },
                attrs: {
                  "current-page": _vm.queryParams.page,
                  "page-size": _vm.queryParams.limit,
                  total: _vm.total,
                  layout: "total, sizes, prev, pager, next, jumper",
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.detailTitle,
            visible: _vm.detailVisible,
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.detailVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { model: _vm.logDetail, "label-width": "120px" } },
            [
              _c("el-form-item", { attrs: { label: "ID" } }, [
                _c("span", [_vm._v(_vm._s(_vm.logDetail.id))]),
              ]),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "状态" } },
                [
                  _c(
                    "el-tag",
                    {
                      attrs: {
                        type: _vm.logDetail.status === 1 ? "success" : "danger",
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.logDetail.status === 1 ? "成功" : "失败") +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("el-form-item", { attrs: { label: "类型" } }, [
                _c("span", [
                  _vm._v(_vm._s(_vm.getTypeText(_vm.logDetail.type))),
                ]),
              ]),
              _vm._v(" "),
              _c("el-form-item", { attrs: { label: "开始时间" } }, [
                _c("span", [_vm._v(_vm._s(_vm.logDetail.startTime))]),
              ]),
              _vm._v(" "),
              _c("el-form-item", { attrs: { label: "结束时间" } }, [
                _c("span", [_vm._v(_vm._s(_vm.logDetail.endTime))]),
              ]),
              _vm._v(" "),
              _c("el-form-item", { attrs: { label: "操作人" } }, [
                _c("span", [_vm._v(_vm._s(_vm.logDetail.createBy))]),
              ]),
              _vm._v(" "),
              _c("el-form-item", { attrs: { label: "创建时间" } }, [
                _c("span", [_vm._v(_vm._s(_vm.logDetail.createTime))]),
              ]),
              _vm._v(" "),
              _c("el-form-item", { attrs: { label: "错误信息" } }, [
                _c("span", [_vm._v(_vm._s(_vm.logDetail.errMsg))]),
              ]),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "请求信息" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "100%" },
                    attrs: { type: "textarea", rows: 10, readonly: "" },
                    model: {
                      value: _vm.logDetail.reqMsg,
                      callback: function ($$v) {
                        _vm.$set(_vm.logDetail, "reqMsg", $$v)
                      },
                      expression: "logDetail.reqMsg",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.detailVisible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }